import {v4 as uuidv4} from 'uuid'
import {
    mapVATCategoryToDropdownVAT,
} from '../../../../../../types/enums.ts'
import type {SalesInvoiceDetail} from '../../../components/salesInvoices/types/salesInvoice.ts'
import type {AddressFieldValue} from '../../../../../../components/general/AddressField.tsx'
import {InvoiceCustomer, InvoiceLineItem} from '../types.ts'
import {CATALOG_UNIT_LABELS} from '../../../../../../types/catalogue.ts'
import type {PaymentTerm, Unit, VATCategory} from '../../../../../../generated/enums.ts';

function toFormUnit(apiUnit: string): Unit {
    return apiUnit in CATALOG_UNIT_LABELS ? apiUnit as Unit : 'piece'
}

function parseCents(value: string | number): number {
    const parsed = Number(value)
    return Number.isFinite(parsed) ? Math.round(parsed) : 0
}

export type DraftFormState = {
    customer: InvoiceCustomer
    address: AddressFieldValue
    lines: InvoiceLineItem[]
    invoiceDate: string
    paymentTerm: PaymentTerm
    poNumber: string
    customerReference: string
    fiscalYear: number | null
    footerText: string
}

export function draftToFormState(detail: SalesInvoiceDetail): DraftFormState {
    const address: AddressFieldValue = {
        street_name: detail.customer_address_street,
        house_number: detail.customer_address_house_number,
        city_name: detail.customer_address_city,
        postal_code: detail.customer_address_postal_code,
        country: detail.customer_address_country || 'NL',
    }

    return {
        customer: {
            id: detail.customer_id ?? `__draft__:${detail.id}`,
            name: detail.customer_name,
            email: detail.customer_email ?? '',
            ccEmail: detail.customer_cc_email ?? '',
            vatNumber: detail.customer_vat_number ?? '',
            addressExtraLine: detail.customer_address_extra_line ?? '',
            address,
            defaultPaymentTerm: detail.payment_term as PaymentTerm,
            isAdHoc: detail.customer_id === null,
        },
        address,
        lines: detail.lines.map((line): InvoiceLineItem => ({
            id: uuidv4(),
            description: line.description,
            quantity: Number(line.quantity) || null,
            unit: toFormUnit(line.unit),
            unitPrice: parseCents(line.unit_price_net_cents) / 100,
            vat: mapVATCategoryToDropdownVAT(
                line.vat_category as VATCategory,
                line.vat_percentage,
            ),
            catalogueItemId: line.catalogue_item_id,
            saveToCatalogue: line.save_to_catalogue,
            serviceStartDate: line.service_start_date,
            serviceEndDate: line.service_end_date,
        })),
        invoiceDate: detail.invoice_date,
        paymentTerm: detail.payment_term as PaymentTerm,
        poNumber: detail.purchase_order_reference ?? '',
        customerReference: detail.customer_specific_reference ?? '',
        fiscalYear: detail.fiscal_year,
        footerText: detail.fixed_footer_text ?? '',
    }
}
